<template>
  <div class="achievement">
    <CommonLayout>
      <div slot="header">
        <h3>技术需求</h3>
      </div>
      <div slot="container">
        <div class="achievement-search">
          <el-button
              icon="el-icon-plus"
              style="background: #623aa2; border: none"
              type="success"
              @click="addAch"
          >新增
          </el-button
          >
          <el-button icon="el-icon-delete" type="danger" @click="deleteAll"
          >批量删除
          </el-button
          >
          <!-- <el-button
            type="primary"
            class="exportOut"
            icon="el-icon-download"
            @click="exportOut"
          >导出</el-button>-->
          <el-popover v-model="visible" placement="bottom" width="300">
            <el-date-picker
                v-model="times"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                style="width: 100%"
                type="daterange"
                value-format="yyyy-MM-dd"
            ></el-date-picker>
            <div style="text-align: right; margin-top: 10px">
              <el-button
                  size="mini"
                  type="text"
                  @click="
                  () => {
                    visible = false;
                    times = null;
                  }
                "
              >取消
              </el-button
              >
              <el-button size="mini" type="primary" @click="exportOut"
              >确定
              </el-button
              >
            </div>
            <el-button
                slot="reference"
                class="exportOut"
                icon="el-icon-download"
                style="margin-left: 10px"
                type="primary"
            >导出
            </el-button
            >
          </el-popover>
          <el-input
              v-model="searchValue"
              class="input-with-select"
              clearable
              placeholder="请输入内容"
              style="width: 240px"
              @clear="search"
              @keyup.enter.native="search"
          >
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
            ></el-button>
          </el-input>
          <label>行业分类:</label>
          <el-select
              v-model="tradeCate"
              clearable
              placeholder="全部"
              style="width: 140px"
              @change="search"
          >
            <el-option
                v-for="(item, index) in typeOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
          <label>需求类别:</label>
          <el-select
              v-model="demandCate"
              clearable
              placeholder="全部"
              style="width: 140px"
              @change="search"
          >
            <el-option
                v-for="(item, index) in demandCateList"
                :key="index"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
          <label>审核状态:</label>
          <el-select
              v-model="examineStatus"
              clearable
              placeholder="全部"
              style="width: 140px"
              @change="search"
          >
            <el-option
                v-for="(item, index) in showOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="achievement-table">
          <el-table
              ref="multipleTable"
              :data="tableData"
              :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
              class="table"
              style="width: 100%"
              @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
                align="center"
                label="序号"
                type="index"
                width="150"
            >
              <template slot-scope="scope">
                <span>{{
                    scope.$index + (current_page - 1) * per_page + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="需求名称"
                prop="name"
            ></el-table-column>
            <el-table-column align="center" label="需求简介">
              <template slot-scope="scope">
                <!-- <span v-html="scope.row.content" style="display:block;height:23px;overflow: hidden;"></span> -->
                <span style="display: block; height: 23px; overflow: hidden">{{
                    GetTarg(scope.row.content)
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="申请时间"
                prop="dateTime"
            ></el-table-column>
            <el-table-column
                align="center"
                label="审核状态"
                prop="examineStatus"
            >
              <template slot-scope="scope">
                <el-tag v-show="scope.row.examineStatus === 1" type="success"
                >通过
                </el-tag
                >
                <el-tag v-show="scope.row.examineStatus === 2" type="info"
                >未通过
                </el-tag
                >
                <el-tag v-show="scope.row.examineStatus === 3" type="danger"
                >待审核
                </el-tag
                >
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="240">
              <template slot-scope="scope">
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"
                >编辑
                </el-button
                >
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            :current-page.sync="current_page"
            :page-size="per_page"
            :total="total"
            layout="total,prev, pager, next"
            style="text-align: left; margin: 20px 0"
            @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </CommonLayout>
    <el-dialog
        :close-on-click-modal="false"
        :title="Title"
        :visible.sync="dialogFormVisible"
        @closed="is_submit = true"
    >
      <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="demo-ruleForm"
          label-width="100px"
      >
        <div class="form-title">基本信息</div>

        <el-row>
          <el-col :span="12">
            <el-row>
              <el-form-item label="需求名称" prop="name">
                <el-input
                    v-model="form.name"
                    clearable
                    placeholder="请输入需求名称"
                ></el-input>
              </el-form-item>
            </el-row>

            <el-row>
              <el-form-item label="行业分类" prop="tradeCate">
                <el-select
                    v-model="form.tradeCate"
                    placeholder="请选择行业分类"
                    style="width: 100%"
                >
                  <el-option
                      v-for="(item, index) in typeOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="需求类别" prop="demandCate">
                <el-select
                    v-model="form.demandCate"
                    placeholder="请选择需求分类"
                    style="width: 100%"
                >
                  <el-option
                      v-for="(item, index) in demandCateList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发布时间" prop="dateTime">
              <el-date-picker
                  v-model="form.dateTime"
                  :picker-options="pickerOptions"
                  format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="width: 100%"
                  type="date"
                  value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="合作方式" prop="cooperateWays">
            <el-input
                v-model="form.cooperateWays"
                clearable
                placeholder="请输入合作方式"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row></el-row>
        <div class="form-title">需求来源</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactName">
              <el-input
                  v-model="form.contactName"
                  clearable
                  placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                  v-model="form.contactPhone"
                  clearable
                  placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="通信地址" prop="detailed">
            <v-distpicker
                :area="form.address.area.value"
                :city="form.address.city.value"
                :province="form.address.province.value"
                style="text-align: left"
                @selected="citySelected"
            ></v-distpicker>
            <el-input
                v-model="form.detailed"
                placeholder="请填写详细地址"
                style="margin-top: 10px"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位名称" prop="companyName">
              <el-input
                  v-model="form.companyName"
                  clearable
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位性质" prop="companyNature">
              <!-- <el-cascader
                placeholder="请选择"
                style="width:100%"
                v-model="form.naturalArr"
                :options="options.source"
                :props="{ multiple: true }"
                clearable
              ></el-cascader>-->
              <el-select
                  v-model="form.companyNature"
                  clearable
                  placeholder="请选择"
                  style="width: 100%"
              >
                <el-option
                    v-for="(item, index) in options.source1"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-title">需求简介</div>
        <el-row>
          <el-form-item label="需求简介" prop="content">
            <editor
                v-model="form.content"
                :img-show-url="imgUrl"
                :upload-url="uploadURL"
            ></editor>
          </el-form-item>
          <el-col :span="24" class="flex-end">
            <el-button type="primary" @click="getTopKey"
            >点击获取关键词
            </el-button
            >
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="12">
            <el-row>
              <el-form-item
                  label="审核人"
                  prop="checkerId"
                  style="text-align: left"
              >
                <el-select v-model="form.checkerId" placeholder="请选择" style="width:100%" @change="changeCheck()">
                  <el-option
                      v-for="(item, index) in checkerOption"
                      :key="index"
                      :label="item.username"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item
                  label="审核状态"
                  prop="examineStatus"
                  style="text-align: left"
              >
                <el-select
                    v-model="form.examineStatus"
                    :disabled="!isCheck || !isChecker"
                    placeholder="请选择"
                    style="width: 100%"
                >
                  <el-option
                      v-for="(item, index) in showOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关键字" prop="keywords">
              <el-select
                  v-model="form.keywords"
                  allow-create
                  default-first-option
                  filterable
                  multiple
                  placeholder="请选择文章标签"
                  style="width: 100%"
                  @change="changeKeyWords"
              >
                <el-option
                    v-for="(item, index) in ResourceKeys"
                    :key="index"
                    :label="item.key"
                    :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-button type="primary" @click="submitForm('form')"
            >提交
            </el-button
            >
            <el-button @click="closeForm('form')">取消</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonLayout from "../../components/common-layout.vue";
import editor from "../../components/tinymce-editor/tinymce-editor";
import {DisabledDateFn} from "@/utils/tool";
import {getToken} from "@/utils/auth";
import {download1} from "@/utils/download";
// import editor from "../../components/yhQuillEditor";
export default {
  components: {
    editor,
    CommonLayout,
  },
  data() {
    return {
      isCheck: false,
      isChecker: false,
      is_submit: true,
      times: "",
      visible: false,
      fieldValue: "",
      tradeValue: "",
      examineStatus: "",
      naturalValue: "",
      typeValue: "",
      wayValue: "",
      deleteRow: "",
      total: 10,
      per_page: 10,
      current_page: 1,
      checkAll: false,
      isIndeterminate: false,
      image: "",
      searchValue: "",
      dialogFormVisible: false,
      Title: "新增",
      tableData: [],
      ResourceKeys: [],
      tradeCate: "",
      demandCate: "",
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      fileList: [],
      form: {
        patent_status: "", //专利状态
        trade_amount: "", //交易金额
        demandCate: "",
        name: "", ///名称
        tradeCate: "", ////行业分类
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        dateTime: "", //////发布时间
        detailed: "", /////详细地址
        cooperateWays: "", ///////合作方式
        contactName: "", ///联系人
        contactPhone: "", ///联系电话
        content: "", ///内容
        examineStatus: 2, ////审核状态
        keywords: [], ////关键词
        companyName: "", //////单位名称
        companyNature: "", //////单位性质
        checkerId: "",
      },
      demandCateList: [
        {
          label: "技术难题",
          value: "001",
        },
        {
          label: "技术开发",
          value: "002",
        },
        {
          label: "技术人才",
          value: "003",
        },
        {
          label: "项目投资",
          value: "004",
        },
        {
          label: "融资需求",
          value: "005",
        },
        {
          label: "其他",
          value: "006",
        },
      ],
      showOptions: [
        {
          value: 3,
          label: "待审核",
        },
        {
          value: 1,
          label: "通过",
        },
        {
          value: 2,
          label: "未通过",
        },
      ],
      options: {
        source1: [
          {
            value: "001",
            label: "民营企业",
          },
          {
            value: "002",
            label: "国有企业",
          },
          {
            value: "003",
            label: "其他",
          },
        ],
        cooperation: [
          {
            value: "001",
            label: "委托开发",
          },
          {
            value: "002",
            label: "许可转让",
          },
          {
            value: "003",
            label: "完全转让",
          },
          {
            value: "004",
            label: "技术入股",
          },
          {
            value: "005",
            label: "技术许可",
          },
          {
            value: "006",
            label: "合作转化",
          },
          // {
          //   value: "007",
          //   label: "自我转化"
          // },
          {
            value: "008",
            label: "其他",
          },
        ],
      },

      typeOptions: [
        {
          value: "001",
          label: "装备制造",
        },
        {
          value: "002",
          label: "材料",
        },
        {
          value: "003",
          label: "能源",
        },
        {
          value: "004",
          label: "环境保护",
        },
        {
          value: "005",
          label: "海洋工程",
        },
        {
          value: "006",
          label: "航空航天",
        },
        {
          value: "007",
          label: "电子信息",
        },
        {
          value: "008",
          label: "其他",
        },
      ],
      rules: {},
      checkerOption: [],
    };
  },
  created() {
    this.getCheck();
    this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/tech-need/page`, {page: this.current_page});
    this.getKey();
  },
  methods: {
    //审核人
    getCheck() {
      this.http
          .post(`${urlConfig.devUrl}apij2/admin-api/system/user/page`, {type: 2, isChecker: 1, checkerModuleId: 6})
          .then((res) => {
            if (res.code === 0) {
              this.checkerOption = res.data.data;
            }
          });
    },
    changeCheck() {
      this.isChecker = this.form.checkerId == getToken() ? true : false;
      this.isCheck = this.form.checkerId ? true : false;
    },
    // 监听关键词变更
    changeKeyWords(val) {
      if (val.length > 5) {
        this.$message.warning("最多5个关键词");
        this.form.keywords = val.slice(0, 5);
      }
    },
    // 获取关键词

    async getTopKey() {
      let str = this.GetTarg(this.form?.content);
      let data = await this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/resource-key/automaticRetrieval`, {content: str});
      this.form.keywords = data.data.map((el) => el.key);
    },
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },

    //导出
    exportOut() {
      let url = "";
      if (this.times) {
        url =
            `${urlConfig.devUrl}apij2/admin-api/trade/tech-need/export-excel?startTime=` +
            this.times[0] +
            "&endTime=" +
            this.times[1];
      } else {
        url = `${urlConfig.devUrl}apij2/admin-api/trade/tech-need/export-excel`;
      }
      download1(url, '军民融合-科技成果.xls');
    },
    getKey() {
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/resource-key/listAll`).then((res) => {
        if (res.code === 0) {
          this.ResourceKeys = res.data;
        }
      });
    },
    getData(url, data) {
      this.http.post(url, data).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page * 1;
        }
      });
    },
    //新增
    addAch() {
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.isCheck = false;
      this.isChecker = false;
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.form = {
        name: "", ///名称
        tradeCate: "", ////行业分类
        address: {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        },
        dateTime: "", //////发布时间
        detailed: "", /////详细地址
        cooperateWays: "", ///////合作方式
        contactName: "", ///联系人
        contactPhone: "", ///联系电话
        content: "", ///内容
        examineStatus: 3, ////审核状态
        keywords: "", ////关键词
        companyName: "", //////单位名称
        companyNature: "", //////单位性质
        checkerId: "",
      };
    },
    //编辑
    handleEdit(index, row) {
      this.isCheck = row.checkerId ? true : false;
      this.isChecker = row.checkerId == getToken() ? true : false;
      this.dialogFormVisible = true;
      this.Title = "编辑";
      this.form = JSON.parse(JSON.stringify(row));
      this.form.address = JSON.parse(row.address);
      if (!this.form.address.province) {
        this.form.address = {
          province: {
            value: "甘肃省",
          },
          city: {
            value: "兰州市",
          },
          area: {
            value: "城关区",
          },
        };
      }
      this.form.detailed = this.form.address.detailed;
      this.form.examineStatus = Number(this.form.examineStatus);
      this.form.keywords = row.keywords ? row.keywords.split(",") : [];
      this.form.checkerId = row.checkerId ? row.checkerId : "";
    },
    //翻页
    handleCurrentChange(e) {
      this.getData(
          `${urlConfig.devUrl}apij2/admin-api/trade/tech-need/page`,
          {
            keyword: this.searchValue,
            page: e,
            tradeCate: this.tradeCate,
            examineStatus: this.examineStatus
          }
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length !== 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.http.delete(`${urlConfig.devUrl}apij2/admin-api/trade/tech-need/delete?id=${row.id}`).then((res) => {
              if (res.code === 0) {
                this.search();
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
            .then(() => {
              this.http
                  .delete(`${urlConfig.devUrl}apij2/admin-api/trade/tech-need/deleteAll?ids=${this.deleteRow}`)
                  .then((res) => {
                    if (res.code === 0) {
                      this.search();
                      this.$message({
                        type: "success",
                        message: "删除成功",
                      });
                    } else {
                      this.$message({
                        message: "失败！",
                        type: "error",
                      });
                    }
                  });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    //获取经纬度
    factory(name) {
      // this.subData(name);
      this.$jsonp(
          "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          this.form.detailed +
          "&city=" +
          this.form.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
          .then((json) => {
            let arr = json.pois[0].location.split(",");
            this.form.lng = arr[0];
            this.form.lat = arr[1];
            this.subData(name);
          })
          .catch((err) => {
            // this.subData(name);
            this.$message.error("未获取到经纬度,请查看地址是否完整");
            this.is_submit = true;
          });
    },
    subData(name) {
      let obj = JSON.parse(JSON.stringify(this.form));
      let arr = [];
      obj.address.detailed = this.form.detailed;
      let area = [
        {
          name: "兰州市",
          id: "001",
        },
        {
          name: "嘉峪关市",
          id: "002",
        },
        {
          name: "金昌市",
          id: "003",
        },
        {
          name: "白银市",
          id: "004",
        },
        {
          name: "天水市",
          id: "005",
        },
        {
          name: "武威市",
          id: "006",
        },
        {
          name: "张掖市",
          id: "007",
        },
        {
          name: "酒泉市",
          id: "008",
        },
        {
          name: "平凉市",
          id: "009",
        },
        {
          name: "庆阳市",
          id: "010",
        },
        {
          name: "定西市",
          id: "011",
        },
        {
          name: "陇南市",
          id: "012",
        },
        {
          name: "临夏回族自治州",
          id: "013",
        },
        {
          name: "甘南藏族自治州",
          id: "014",
        },
      ];
      area.forEach((item) => {
        if (obj.address.city.value === item.name) {
          obj.area = item.id;
        }
      });
      obj.address = JSON.stringify(obj.address);
      if (obj.keywords.length) {
        obj.keywords = obj.keywords.join(",");
      }
      if (!this.form.id) {
        this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/trade/tech-need/create`, obj)
            .then((res) => {
              if (res.code === 0) {
                this.search();
                this.getKey();
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
              } else {
                this.is_submit = true;
              }
            })
            .catch((err) => {
              this.is_submit = true;
            });
      } else {
        this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/trade/tech-need/update`, obj)
            .then((res) => {
              if (res.code === 0) {
                this.search();
                this.getKey();
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
              } else {
                this.is_submit = true;
              }
            })
            .catch((err) => {
              this.is_submit = true;
            });
      }
    },
    //提交
    submitForm(name) {
      if (!this.is_submit) return false;
      this.is_submit = false;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.factory(name);
        } else {
          this.is_submit = true;
          return false;
        }
      });
    },
    //数组去重
    unique(arr) {
      return arr.filter((ele, index, array) => {
        return array.indexOf(ele) === index;
      });
    },
    //关闭
    closeForm(name) {
      this.$refs[name].resetFields();
      this.checkAll = false;
      this.isIndeterminate = false;
      this.dialogFormVisible = false;
    },
    //查找
    search() {
      this.getData(
          `${urlConfig.devUrl}apij2/admin-api/trade/tech-need/page`,
          {
            keyword: this.searchValue,
            page: 1,
            tradeCate: this.tradeCate,
            examineStatus: this.examineStatus
          }
      );
    },
    //审核
    release(row, type) {
      let obj = {
        is_show: type,
      };
      this.$jsonp(
          "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          row.address.detailed +
          "&city=" +
          row.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
          .then((json) => {
            let arr = json.pois[0].location.split(",");
            obj.lng = arr[0];
            obj.lat = arr[1];
            this.http.put("tech_need/" + row.id, obj).then((res) => {
              if (res.code === 0) {
                if (type === 1) {
                  this.$message.success("审核通过");
                } else {
                  this.$message.success("审核不通过");
                }
                this.search();
                // this.getData("tech_need?all=1&page=1");
              }
            });
          })
          .catch((err) => {
            this.http.put("tech_need/" + row.id, obj).then((res) => {
              if (res.code == 0) {
                if (type == 1) {
                  this.$message.success("审核通过");
                } else {
                  this.$message.success("审核不通过");
                }
                this.search();
                // this.getData("tech_need?all=1&page=1");
              }
            });
            this.$message.error("未获取到经纬度,请查看地址是否完整");
          });
    },
    //富文本
    getQuillData(val) {
      this.form.introduction = val;
    },
    //城市选择
    citySelected(e) {
      this.form.address = e;
    },
    //关注领域
    // handleCheckAllChange(val) {
    //   this.form.checked = val ? this.checkList : [];
    //   this.isIndeterminate = false;
    // },
    // handleCheckedCitiesChange(value) {
    //   let checkedCount = value.length;
    //   this.checkAll = checkedCount === this.checkList.length;
    //   this.isIndeterminate =
    //     checkedCount > 0 && checkedCount < this.checkList.length;
    // },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, "HouImg");
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
          .then((rst) => {
            this.http
                .post("/file/base64_upload", {
                  image: rst.base64,
                })
                .then((res) => {
                  this.form.logo = res.data;
                });
            return rst;
          })
          .always(() => {
            // 清空文件上传控件的值
            e.target.value = null;
          });
    },

    handlePictureCardPreview(file) {
      this.form.logo = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
          file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/jpg" ||
          file.type === "image/gif" ||
          file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.form.logo = "";
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.achievement {
  width: 100%;
  height: 100%;

  .achievement-search {
    width: 100%;
    text-align: left;

    // margin-top: 20px;
    .el-select {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    .el-cascader {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    .el-input {
      margin: 0 15px;
    }
  }

  .achievement-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }

  .form-title {
    width: 100%;
    text-align: left;
    color: #0572a4;
    border-left: 5px solid #0572a4;
    border-bottom: 1px solid #0572a4;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
